// @ts-check

import { defineComponent, h } from 'vue'
import { VBtn } from 'vuetify/components/VBtn'

/**
 * Custom button component that disables itself when loading is true.
 * Done because VBtn doesn't disable itself when loading prop set and Vuetify expects this behavior
 * Vuetify issue: https://github.com/vuetifyjs/vuetify/issues/17396
 */
const ExtendedButton = defineComponent({
  name: 'ExtendedButton',
  inheritAttrs: false,
  props: VBtn.props,
  setup(props, { slots, attrs }) {
    return () =>
      h(
        VBtn,
        {
          ...props,
          ...attrs,
          disabled: props.loading || props.disabled
        },
        slots
      )
  }
})

/** @type {VBtn['$props']} */
const ButtonProps = {
  ripple: typeof jest === 'undefined',
  rounded: true,
  variant: 'flat',
  class: [
    'font-primary',
    'font-medium',
    'normal-case',
    'leading-5',
    'tracking-normal',
    'text-sm'
  ],
  color: 'primary'
}

/** @type {VBtn['$props']} */
export const PrimaryButton = {
  ...ButtonProps,
  class: [...ButtonProps.class, 'btn-primary', 'text-white'],
  variant: 'flat'
}

/** @type {VBtn['$props']} */
export const SecondaryButton = {
  ...ButtonProps,
  class: [...ButtonProps.class, 'btn-secondary', 'border-2', 'border-primary'],
  variant: 'outlined'
}

/** @type {VBtn['$props']} */
export const TextButton = {
  ...ButtonProps,
  class: [...ButtonProps.class, 'btn-text', 'hover:underline'],
  variant: 'text'
}

/** @type {VBtn['$props']} */
export const IconButton = {
  ...ButtonProps,
  class: [...ButtonProps.class, 'btn-icon'],
  rounded: 'xl',
  size: 'x-small',
  variant: 'text',
  color: 'secondary-600'
}

export const aliases = {
  PrimaryButton: ExtendedButton,
  SecondaryButton: ExtendedButton,
  TextButton: ExtendedButton,
  IconButton: ExtendedButton
}

export const defaults = {
  PrimaryButton,
  SecondaryButton,
  TextButton,
  IconButton
}
